import { render, staticRenderFns } from "./UsecaseContent.vue?vue&type=template&id=2e9fec4c"
import script from "./UsecaseContent.vue?vue&type=script&lang=js"
export * from "./UsecaseContent.vue?vue&type=script&lang=js"
import style0 from "./UsecaseContent.vue?vue&type=style&index=0&id=2e9fec4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports